// This function should return the product data for the given ID. If the product data does not exist for the given ID, it should return undefined.

function getProductData(arr, id) {
    
    // console.log(id)
    let productData = arr.find(product => product.id === id);
        // console.log(arr)
        // console.log(arr,id)
    if (productData === undefined) {
        // console.log("Product data does not exist for ID: " + id);
        return undefined;
    }

    return productData;
}


export { getProductData };